export default __webpack_public_path__ + "static/media/google.1d580594.svg";